function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo, useState } from 'react';
import { Button, Card, TextButton, Typography, Popover } from 'seagull';
import colors from 'seagull/foundations/colors.module.scss';
import styles from "./BrandingControllers.module.scss";
import { ColorSelector } from "../../../components/ColorSelector/ColorSelector";
import { ColorPicker } from "../../../components/ColorPicker/ColorPicker";
import { useCobBranding } from "../CobBrandingContext";
import { LogoPicker } from "../../../components/LogoPicker/LogoPicker";
const SectionTitle = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Typography, {
    weight: "normal"
  }, children);
};
const ColorControllers = _ref2 => {
  let {
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.colorControllers
  }, children);
};
const ColorsLabel = _ref3 => {
  let {
    children
  } = _ref3;
  return /*#__PURE__*/React.createElement(Typography, {
    skin: "secondary"
  }, children);
};
const Separator = () => /*#__PURE__*/React.createElement("div", {
  className: styles.sep
});
function ColorSelectorWithPopup(props) {
  const {
    branding,
    colorKey,
    hasError,
    onChange
  } = props;
  const color = branding[colorKey];
  const [anchorEl, setAnchorEl] = useState(null);
  const presetColors = useMemo(() => [colors.orange900, colors.orange800, colors.orange700, colors.orange500, colors.orange300, colors.orange50, colors.green900, colors.green800, colors.green700, colors.green500, colors.green300, colors.green50, colors.blue800, colors.blue700, colors.blue600, colors.blue500, colors.blue300, colors.blue50, colors.purple900, colors.purple800, colors.purple700, colors.purple500, colors.purple300, colors.purple50, colors.dark900, colors.dark800, colors.dark700, colors.dark500, colors.dark300, colors.dark100, colors.red970, colors.red950, colors.red900, colors.red700, colors.red500, colors.red300], []);
  function changeColor(newColor) {
    onChange(_objectSpread(_objectSpread({}, branding), {}, {
      [colorKey]: newColor
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ColorSelector, {
    withBorder: true,
    color: color,
    hasError: hasError,
    testid: "color-selector-".concat(colorKey),
    onClick: e => setAnchorEl(e.currentTarget)
  }), /*#__PURE__*/React.createElement(Popover, {
    anchorEl: anchorEl,
    open: !!anchorEl,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'center'
    },
    transformOrigin: {
      vertical: -5,
      horizontal: 'center'
    },
    onClose: () => setAnchorEl(null)
  }, /*#__PURE__*/React.createElement(Card, {
    padding: "s"
  }, /*#__PURE__*/React.createElement(ColorPicker, {
    className: styles.colorPicker,
    testid: "color-picker-".concat(colorKey),
    color: color,
    displayColor: color,
    onChange: newColor => changeColor(newColor)
  }), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement("div", {
    className: styles.colorsGrid
  }, presetColors.map((color, idx) => /*#__PURE__*/React.createElement(ColorSelector, {
    withBorder: true,
    key: color,
    color: color,
    testid: "color-preset-".concat(idx),
    onClick: () => changeColor(color)
  }))))));
}
export default function BrandingControllers(_ref4) {
  let {
    worksAt: _
  } = _ref4;
  const {
    branding,
    logoImage,
    errors,
    isDirty,
    isValid,
    setBranding,
    setLogo,
    revertToDefault,
    saveLogoAndBranding
  } = useCobBranding();
  function getColorControl(colorKey) {
    return /*#__PURE__*/React.createElement(ColorSelectorWithPopup, {
      branding: branding,
      hasError: errors.has(colorKey),
      colorKey: colorKey,
      onChange: setBranding
    });
  }
  return /*#__PURE__*/React.createElement(Card, {
    padding: "s"
  }, /*#__PURE__*/React.createElement(SectionTitle, null, "Upload logo"), /*#__PURE__*/React.createElement(LogoPicker, {
    isNewUI: true,
    testid: "upload-logo",
    image: logoImage,
    onChange: setLogo
  }), /*#__PURE__*/React.createElement(SectionTitle, null, "Choose brand colors"), /*#__PURE__*/React.createElement("div", {
    className: styles.colorsSection
  }, /*#__PURE__*/React.createElement(ColorsLabel, null, "Text"), /*#__PURE__*/React.createElement(ColorControllers, null, getColorControl('textStandard'), getColorControl('textSecondary')), /*#__PURE__*/React.createElement(ColorsLabel, null, "Buttons"), /*#__PURE__*/React.createElement(ColorControllers, null, getColorControl('buttonPrimary'), getColorControl('buttonSecondary'), getColorControl('buttonDisabled')), /*#__PURE__*/React.createElement(ColorsLabel, null, "Background"), /*#__PURE__*/React.createElement(ColorControllers, null, getColorControl('backgroundGradientStart'), getColorControl('backgroundGradientEnd'), getColorControl('backgroundLight'), getColorControl('backgroundStandard')), /*#__PURE__*/React.createElement(ColorsLabel, null, "Progress bar"), /*#__PURE__*/React.createElement(ColorControllers, null, getColorControl('progressBarComplete'), getColorControl('progressBarIncomplete'))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TextButton, {
    "data-testid": "undo-color-changes",
    underline: "none",
    onClick: revertToDefault
  }, "Revert to default colors")), /*#__PURE__*/React.createElement(Separator, null), /*#__PURE__*/React.createElement("div", {
    className: styles.saveSection
  }, /*#__PURE__*/React.createElement(Button, {
    skin: "primaryOutline",
    disabled: !isDirty || !isValid,
    "data-testid": "save-colors",
    tooltip: {
      placement: 'top',
      title: !isDirty ? 'Nothing to save' : !isValid ? 'One of the fields is invalid' : ''
    },
    onClick: saveLogoAndBranding
  }, "Save changes")));
}